import experimentFlagsHelper from '@zola-helpers/client/dist/es/util/experimentFlagsHelper';

// LogRocket Keys
export const LOGROCKET_REGISTRY_WEDDING_WEBSITE = 'logrocket-registry-wedding-website'; //
export const LOGROCKET_ALBUM_CUSTOMIZATION = 'logrocket-album-customization'; // COMMERCE-172 https://newamsterdamlabs.atlassian.net/browse/COMMERCE-172
export const LOGROCKET_PLANNING_ONBOARD_FLAG = 'logrocket-planning-onboard';
export const LOGROCKET_WEBSITE_ONBOARD = 'logrocket-website-onboard';
export const SUPER_LINK_LOG_ROCKET = 'magic-link-log-rocket'; // CE-847 https://newamsterdamlabs.atlassian.net/browse/CE-847
export const LOGROCKET_INVITES_PLP = 'logrocket-invites-plp'; // COMMERCE-584 https://newamsterdamlabs.atlassian.net/browse/COMMERCE-584
export const LOGROCKET_INVITES_PDP = 'logrocket-invites-pdp'; // COMMERCE-585 https://newamsterdamlabs.atlassian.net/browse/COMMERCE-585

// Experiment Keys
export const CARDS_PLP_REFRESH = 'cards-plp-refresh';
export const CARDS_MOBILE_FILTERS = 'cards-mobile-filters';
export const CARDS_TILES_NO_BORDER = 'cards-tiles-no-border';
export const INVITES_PROMO_PAPER40 = 'invites-promo-paper40';
export const EDIT_PAGE_FORM = 'edit-page-form';
export const REGISTRY_GIFT_GIVER_TILE_HEIGHT = 'registry-gift-giver-tile-height'; // https://newamsterdamlabs.atlassian.net/browse/COMMERCE-929
export const REGISTRY_GIFT_GIVER_PRE_FILTERED = 'registry-gift-giver-pre-filtered'; // https://newamsterdamlabs.atlassian.net/browse/COMMERCE-930
export const REGISTRY_GIFT_GIVER_PDP_BADGE = 'registry-gift-giver-pdp-badge'; // https://newamsterdamlabs.atlassian.net/browse/COMMERCE-931
export const HOME_NEWNESS = 'home-newness';
export const HOLIDAYS_2021 = 'holidays2021';
export const SKIP_REG_ONBOARD_CLEANUP = 'skip-reg-onboard-cleanup'; // newamsterdamlabs.atlassian.net/browse/CE-1495
export const CUSTOM_DOMAIN_FLOW_MANAGE = 'custom_domain_flow_manage'; // https://newamsterdamlabs.atlassian.net/browse/CE-1512
export const CUSTOM_DOMAIN_FLOW_SETTINGS = 'custom_domain_flow_settings'; // https://newamsterdamlabs.atlassian.net/browse/CE-1513
export const DESKTOP_TO_APP_ENABLED = 'desktop-to-app-enabled'; // https://newamsterdamlabs.atlassian.net/browse/CE-1417
export const GUEST_LIST_DESK_TO_APP = 'guest_list_desk_to_app'; // https://newamsterdamlabs.atlassian.net/browse/CE-1352
export const ALBUMS_PROMO_ALBUMS25 = 'albums25';
export const WEBSITE_TO_REGISTRY = 'website_to_registry'; // https://newamsterdamlabs.atlassian.net/browse/CE-1583
export const INVITES_PAPER_UPSELL = 'invites-paper-upsell'; // https://newamsterdamlabs.atlassian.net/browse/COMMERCE-1062
export const WEBSITE_CUSTOMIZATION_ENABLED = 'website-customization-enabled'; // https://newamsterdamlabs.atlassian.net/browse/CE-1636
export const CARDS_SAMPLES_FLOW = 'cards-samples-flow'; // https://newamsterdamlabs.atlassian.net/browse/COMMERCE-1014
export const POST_ONBOARDING_RW = 'post-onboarding-rw';
export const DSTD_WEDDING_WEBSITE_ENTRYPOINT = 'dstd-wedding-website-entrypoint-ii'; // https://newamsterdamlabs.atlassian.net/browse/COMMERCE-1133
export const HDYHAU_SUBWAY = 'hdyhau-subway';

const FALLBACK_VARIATIONS = {
  // LogRocket Flags
  [LOGROCKET_PLANNING_ONBOARD_FLAG]: experimentFlagsHelper.createExperimentFlags(),
  [LOGROCKET_WEBSITE_ONBOARD]: experimentFlagsHelper.createExperimentFlags(),
  [SUPER_LINK_LOG_ROCKET]: experimentFlagsHelper.createExperimentFlags(),
  [LOGROCKET_ALBUM_CUSTOMIZATION]: experimentFlagsHelper.createExperimentFlags(),
  [LOGROCKET_REGISTRY_WEDDING_WEBSITE]: experimentFlagsHelper.createExperimentFlags(),
  [LOGROCKET_INVITES_PLP]: experimentFlagsHelper.createExperimentFlags(),
  [LOGROCKET_INVITES_PDP]: experimentFlagsHelper.createExperimentFlags(),
  // Experiment Flags
  [CARDS_PLP_REFRESH]: experimentFlagsHelper.createExperimentFlags(),
  [CARDS_TILES_NO_BORDER]: experimentFlagsHelper.createExperimentFlags(),
  [INVITES_PROMO_PAPER40]: experimentFlagsHelper.createExperimentFlags(),
  [EDIT_PAGE_FORM]: experimentFlagsHelper.createExperimentFlags(),
  [HOME_NEWNESS]: experimentFlagsHelper.createExperimentFlags(),
  [HOLIDAYS_2021]: experimentFlagsHelper.createExperimentFlags(),
  [REGISTRY_GIFT_GIVER_TILE_HEIGHT]: experimentFlagsHelper.createExperimentFlags(),
  [REGISTRY_GIFT_GIVER_PRE_FILTERED]: experimentFlagsHelper.createExperimentFlags(),
  [SKIP_REG_ONBOARD_CLEANUP]: experimentFlagsHelper.createExperimentFlags(),
  [REGISTRY_GIFT_GIVER_PDP_BADGE]: experimentFlagsHelper.createExperimentFlags(),
  [CUSTOM_DOMAIN_FLOW_MANAGE]: experimentFlagsHelper.createExperimentFlags(),
  [CUSTOM_DOMAIN_FLOW_SETTINGS]: experimentFlagsHelper.createExperimentFlags(),
  [WEBSITE_TO_REGISTRY]: experimentFlagsHelper.createExperimentFlags(),
  [CARDS_MOBILE_FILTERS]: experimentFlagsHelper.createExperimentFlags(),
  [DESKTOP_TO_APP_ENABLED]: experimentFlagsHelper.createExperimentFlags(),
  [GUEST_LIST_DESK_TO_APP]: experimentFlagsHelper.createExperimentFlags(),
  [ALBUMS_PROMO_ALBUMS25]: experimentFlagsHelper.createExperimentFlags(),
  [INVITES_PAPER_UPSELL]: experimentFlagsHelper.createExperimentFlags(),
  [WEBSITE_CUSTOMIZATION_ENABLED]: experimentFlagsHelper.createExperimentFlags(),
  [CARDS_SAMPLES_FLOW]: experimentFlagsHelper.createExperimentFlags(),
  [POST_ONBOARDING_RW]: experimentFlagsHelper.createExperimentFlags(),
  [DSTD_WEDDING_WEBSITE_ENTRYPOINT]: experimentFlagsHelper.createExperimentFlags(),
  [HDYHAU_SUBWAY]: experimentFlagsHelper.createExperimentFlags(),
};

export default experimentFlagsHelper.makeExperimentFlags(FALLBACK_VARIATIONS);
